import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import FillEmailIcon from "./icon-fill-email.svg";

export const Container = styled.div`
  display: flex;
  align-items: center;

  color: #ffffff;
  font-size: 14px;
  font-family: ${fontRoboto};
  text-transform: uppercase;
`;

export const StyledFillEmailIcon = styled(FillEmailIcon)`
  margin-inline-end: 10px;
`;
